// Use the legacy PDF.js bundle for Safari/WebKit compatibility.
// The modern build relies on newer JS features that are not available in all
// Safari versions we still need to support in staging/production.
import { GlobalWorkerOptions, getDocument } from "pdfjs-dist/legacy/build/pdf.mjs";

GlobalWorkerOptions.workerSrc = new URL("pdfjs-dist/legacy/build/pdf.worker.min.mjs", import.meta.url).toString();

export { getDocument };
